module.exports = __webpack_public_path__ + "05b777b7ff16829cd6e8246a0b4654ef.MP3";